// extracted by mini-css-extract-plugin
export default {"FacebookPosts":"FacebookPosts_FacebookPosts__AVKAW"};